


namespace GeniuzPOS.Product {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsSetItemDialog extends Serenity.EntityDialog<PsSetItemRow, any> {
        protected getFormKey() { return PsSetItemForm.formKey; }
        protected getIdProperty() { return PsSetItemRow.idProperty; }
        protected getLocalTextPrefix() { return PsSetItemRow.localTextPrefix; }
        protected getNameProperty() { return PsSetItemRow.nameProperty; }
        protected getService() { return PsSetItemService.baseUrl; }
        protected getDeletePermission() { return PsSetItemRow.deletePermission; }
        protected getInsertPermission() { return PsSetItemRow.insertPermission; }
        protected getUpdatePermission() { return PsSetItemRow.updatePermission; }

        protected form = new PsSetItemForm(this.idPrefix);

        // public a : list[];

        constructor() {
            super();

            
            

            this.form.SetItemCode.changeSelect2(e => {
                var pludesc = Q.toId(this.form.SetItemCode.value);
                if (pludesc != null) {
                    this.form.SetItemName.value = Lookups.VwPluLookupSetItemRow.getLookup().itemById[pludesc].PluDesc;
                    this.form.SetItemShortName.value = Lookups.VwPluLookupSetItemRow.getLookup().itemById[pludesc].PluShortDesc;
                    this.form.SetItemUnit.value = Lookups.VwPluLookupSetItemRow.getLookup().itemById[pludesc].SellUnit;
                    this.form.SetPrice.value = Lookups.VwPluLookupSetItemRow.getLookup().itemById[pludesc].SellUnitPrice1;
                }
            });

            this.form.SetItemCode.addValidationRule(this.uniqueName, e => {
                var SetItemCode = this.form.SetItemCode.value;
               
                 var h = Q.tryFirst(PsSetItemRow.getLookup().items, x => x.SetItemCode == SetItemCode)
                 if (h != null) {   
                    Q.warning("SetItemCode already exists! Please edit on the existing record. ต้องการปรับสินค้าชุดให้แก้ไขจากสินค้าชุดเดิม")
                    return "SetItemCode already exists! Please edit on the existing record.";
                   
                 }
                
            });


            this.form = new PsSetItemForm(this.idPrefix);
            // this.form.PostFg.element.parent();
            (this.form.PsSetItemDtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
                var s = this.form.PsSetItemDtList.view
                this.form.SetPrice.value = new Slick.Aggregators.Sum('SetUnitPrice')
                // new Slick.Aggregators.Sum('SetUnitPrice')
                
            });
            // this.form.PsSetItemDtList.changeSelect2(e => {
                var d = Q.toId(this.form.PsSetItemDtList.value);
                console.log(d)
            // });

            
            if (!this.isNew()) { } else {
                this.form.SetItemName.changeSelect2(e => {
                    var pludesc = Q.toId(this.form.SetItemName.value);
                    if (pludesc != null) {
                        this.form.SetItemShortName.value = (this.form.SetItemName.value).substring(0, 40);
                    }
                });
            }
        }

        protected initToolbar() {
            super.initToolbar();

        }

        // public setPurOrderDetails(details: PurOrderRow){
        //     this.form.ForeignType.value = String(details.ForeignType);
        //     this.form.SupplId.value = String(details.SupplId);
        //     this.form.CrtId.value = String(details.CrtId);
        //     this.form.CurcyId.value = String(details.CurcyId);
        //     this.form.ExchangeRate.value = details.ExchangeRate;
        //     this.form.DueDate.value = details.DueDate;
        //     this.form.ETADate.value = details.ETADate;
        //     this.form.ETDDate.value = details.ETDDate;
        //     this.form.IncoId.value = String(details.IncoId);
        //     this.form.VatRate.value = String(details.VatRate);
        //     this.form.ShipDate.value = details.ShipDate;
        //     this.form.BranchId.value = details.BranchId.toString();
        //     this.form.WhsId.value = details.WhsId.toString();
        //     this.form.ProjId.value = String(details.ProjId);
        //     this.form.DeptId.value = String(details.DeptId);
        //     this.form.Remark.value = details.Remark;
        //     this.form.DiscString.value = parseFloat(details.DiscString);
        //     this.form.ShipAddress.value = details.ShipAddress;
        //     this.form.ShipVia.value = details.ShipVia;
        // }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

          
                // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
             
            
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        this.dialogClose();
     
                    },
                }
            );

         

            return buttons;
        }
        protected beforeLoadEntity() {
            let self = this;
            self.toolbar.findButton('save-and-close-button').text('บันทึกเอกสาร');
            self.toolbar.findButton('delete-button').text('ลบเอกสาร');

            //this.form.ReceiveDtList.myPassValue = this.entity.SysDocNo
            //if (this.isNew()) {
            //    this.getNextNumber();
            //}

        }
        protected afterLoadEntity() {
            super.afterLoadEntity();

            

            ////----
            let self = this;
            let nbrRetry = 0;

            // this.toolbar.findButton('cal-auto').insertAfter(this.form.SetPrice.element);

            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();

            var Plucheck = Q.tryFirst(Inventory.IcStockSetAssembleRow.getLookup().items, x => x.SetItemCode == this.form.SetItemCode.value);
           console.log(Plucheck)
            if (Plucheck != null) {
                this.deleteButton.toggleClass('disabled', true);//
                this.saveAndCloseButton.toggleClass('disabled', true);//
                this.toolbar.findButton('save-and-close-button').hide();
              

            }

        }
    
        protected getSaveEntity(): PsSetItemRow {
            let entity = super.getSaveEntity();

            return entity;
        }
    }
}